import { pointNearLine } from '../../utils/geometry';
import paper from 'paper';
import { ConnectorEnd } from '../../types';
import type Connector from '../../objects/Connector';
import { type IPoint } from 'fabric/fabric-impl';

// Router for creating straight lines.
//
// `points` holds the endpoints of each segment of the line.
// `controlPoints` holds the endpoints of each segment of the line.
class RouterStraight {
  static computeControlPoints(connector: Connector) {
    connector.controlPoints = [...connector.points];
  }

  static pointNearLineSegment(
    connector: Connector,
    point: IPoint,
    index: number,
    radius: number
  ) {
    return pointNearLine(
      point,
      connector.points[index],
      connector.points[index + 1],
      radius
    );
  }

  static pointOnLine(connector: Connector, t: number) {
    const path = this._constructPaperPath(connector);
    const offset = t * path.length;
    const point = path.getPointAt(offset);
    const tangent = path.getTangentAt(offset);

    return { x: point.x, y: point.y, angle: tangent.angle };
  }

  static closestPointOnPath(connector: Connector, point: IPoint) {
    const path = this._constructPaperPath(connector);

    const pointOnPath = path.getNearestPoint(new paper.Point(point.x, point.y));
    return path.getOffsetOf(pointOnPath) / path.length;
  }

  // TODO can we cache this?
  static _constructPaperPath(connector: Connector) {
    const points = connector.controlPoints;

    const path = new paper.Path();

    path.moveTo(new paper.Point(points[0].x, points[0].y));
    for (let i = 1; i < points.length; i++) {
      path.lineTo(new paper.Point(points[i].x, points[i].y));
    }

    return path;
  }

  static midPoint(connector: Connector, afterIndex: number) {
    return {
      x:
        (connector.points[afterIndex].x + connector.points[afterIndex + 1].x) /
        2,
      y:
        (connector.points[afterIndex].y + connector.points[afterIndex + 1].y) /
        2,
    };
  }

  static drawLine(connector: Connector, ctx: CanvasRenderingContext2D) {
    const len = connector.points.length;
    const x = connector.pathOffset.x;
    const y = connector.pathOffset.y;

    ctx.moveTo(connector.points[0].x - x, connector.points[0].y - y);
    for (let i = 1; i < len; i++) {
      const point = connector.points[i];
      ctx.lineTo(point.x - x, point.y - y);
    }
  }

  static arrowHeadLine(connector: Connector, whichEnd: ConnectorEnd) {
    if (whichEnd === ConnectorEnd.CONNECTOR_START) {
      return {
        from: connector.controlPoints[1],
        to: connector.points[0],
      };
    } else {
      return {
        from: connector.controlPoints[connector.controlPoints.length - 2],
        to: connector.points[connector.points.length - 1],
      };
    }
  }
}

export default RouterStraight;
